import Vue from "vue";
import Router from "vue-router";
import store from "../store/store";
import myaxios from '../axios/api';
let Chushi = () => import("@/view/chushi");//初始页面
let Shouye = () => import("@/view/tab/home");//初始页面
let activDetails = () => import("@/view/tab/activDetails");//活动页
let shopCart = () => import("@/view/tab/shopCart");//购物车
let homeClassify = () => import("@/view/tab/homeClassify");//分类
let MyShop = () => import("@/view/tab/myShop");//我的
let activityDetails = () => import('@/components/activity/activityDetails') //套餐包详情
let wSzizhi = () =>
    import("@/components/qualifications/wSzizhi");

let Sousuo = () =>
    import("@/components/sousuo");
let Sousuo1 = () =>
    import("@/components/Sousuo1");
let ShopDetails = () =>
    import("@/components/shopDetails");
let groupDetails = () =>
    import("@/components/activity/groupDetails");
let buyerQuery = () =>
    import("@/components/activity/buyerQuery");
let tetui = () =>
    import("@/components/tetui");
let ShopDetailscoll = () =>
    import("@/components/ShopDetailscoll");
let ShopList = () =>
    import("@/components/shoplist/shopList"); //商品列表
let productlist = () =>
    import("@/components/shoplist/productlist"); //商品列表
let changeInfo = () =>
    import("@/components/changeInfo");
let ShopDetailsPL = () =>
    import("@/components/shopDetailsPL");
let OrderList = () =>
    import("@/components/orderList");
let OrderListDetails = () =>
    import("@/components/orderListDetails");
let GouwucheTJDD = () =>
    import("@/components/gouwucheTJDD");
let GuoWuCheDel = () =>
    import("@/components/guoWuCheDel");
let Register = () =>
    import("@/components/register");
let MyYHJ = () =>
    import("@/components/myYHJ");
let Openbank = () =>
    import("@/components/openbank");
let Zhong = () =>
    import("@/components/Zhong");
let ceshi = () =>
    import("@/components/ceshi"); //分类活动
let hdongy = () =>
    import("@/components/hdongy"); //分类活动
let broadcast = () =>
    import("@/components/broadcast"); //直播
let enterbroadcast = () =>
    import("@/components/enterbroadcast"); //直播KFservice
let KFservice = () =>
    import("@/components/KFservice");
let returnGoods = () =>
    import("@/components/returnGoods");
let returnGoods1 = () =>
    import("@/components/returnGoods1");
let returnGoods2 = () =>
    import("@/components/returnGoods2");
let refundInformation = () =>
    import("@/components/refundInformation");
let UserInfo = () =>
    import("@/components/userInfo");
let Address = () =>
    import("@/components/address");
let AddressUpdata = () =>
    import("@/components/addressUpdata");
let MySC = () =>
    import("@/components/mySC");
let ResetPassword = () =>
    import("@/components/resetPassword");
let OrderDetailsCZ = () =>
    import("@/components/orderDetailsCZ");
let Pingjia = () =>
    import("@/components/pingjia");

let LqYHJ = () =>
    import("@/components/lqYHJ");
let Ok = () =>
    import("@/components/ok");
let loginMima = () =>
    import("@/components/loginMima");
let loginYzm = () =>
    import("@/components/loginYzm");
let WJpassword = () =>
    import("@/components/WJpassword");
let addressUpdataX = () =>
    import("@/components/addressUpdataX");
let shezhi = () =>
    import("@/components/shezhi");

let activDetailsWarp = () =>
    import("@/components/activDetailsWarp");
let advertisement = () =>
    import("@/components/advertisement");
let logistics = () =>
    import("@/components/logistics");

let Hdong = () =>
    import("@/components/hdong");
let footprint = () =>
    import("@/components/footprint");
let Chgzhifu = () =>
    import("@/components/chgzhifu");
let Yinsi = () =>
    import("@/components/yinsi");
let Fuwu = () =>
    import("@/components/fuwu");
let Bangka = () =>
    import("@/components/bangka");
let Qrbangk = () =>
    import("@/components/qrbangk");
let videolist = () =>
    import("@/components/videolist");
let videochapter = () =>
    import("@/components/videochapter");
let videodetails = () =>
    import("@/components/videodetails");
let Merchant = () =>
    import("@/components/Merchant");
let news = () =>
    import("@/components/news");
let newlist = () =>
    import("@/components/newlist");
let shopNotice = () =>
    import("@/components/shopNotice");
let newShopResgister = () =>
    import("@/components/newShopResgister");
let newShop = () =>
    import("@/components/newShop");
let banklist = () =>
    import("@/components/banklist");
let photocopy = () =>
    import("@/components/photocopy");
let openAccount = () =>
    import("@/components/openAccount");
let shop = () =>
    import("@/components/shop/shop"); //
let shoplist = () =>
    import("@/components/shop/shoplist"); //
let collage = () =>
    import("@/components/collage");
let Invoice = () =>
    import("@/components/seeinvoice.vue");
let OfThePublic = () =>
    import("@/components/OfThePublic.vue");
let aboutUs = () =>
    import("@/components/aboutUs.vue");
let theCharts = () =>
    import("@/components/theCharts.vue");
let bigWheel = () =>
    import("../view/bigWheel/bigWheel.vue");
let iframes = () =>
    import("../components/iframe.vue");
Vue.use(Router);
const scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition) {
        //保持原先的滚动位置
        store.commit("addCount", to.name);
        store.commit("delCount", from.name);
    }
};
const route = new Router({
    // mode: "history",
    scrollBehavior,
    routes: [{
        path: "/",
        name: "Chushi",
        component: Chushi,
        meta: {
            title: "康药药控销商城",
            name: "首页",
            keepAlive: true // 需要缓存
        },
        children: [{
            path: "/",
            name: "Shouye",
            component: Shouye,
            meta: {
                title: "康药药控销商城",
                name: "首页",
                keepAlive: true, // 需要缓存
            }
        },
        {
            path: "homeClassify",
            name: "homeClassify",
            component: homeClassify,
            meta: {
                title: "康药药控销商城",
                name: "分类",
                keepAlive: true, // 需要缓存
            }
        },
        {
            path: "shopCart",
            name: "shopCart",
            component: shopCart,
            meta: {
                title: "康药药控销商城",
                name: "购物车",
                keepAlive: false, // 需要缓存
            }
        },
        {
            path: "MyShop",
            name: "MyShop",
            component: MyShop,
            meta: {
                title: "康药药控销商城",
                keepAlive: false,
                name: "我的",
                isLogin: true,
            }
        },
        {
            path: "/activDetails",
            name: "activDetails",
            component: activDetails,
            meta: {
                title: "康药药控销商城",
                name: "活动",
                keepAlive: true
            }
        },
        ]
    },
    {
        path: "/Sousuo",
        name: "Sousuo",
        component: Sousuo,
        meta: {
            title: "搜索",
            keepAlive: true
        }
    },
    {
        path: "/Sousuo1",
        name: "Sousuo1",
        component: Sousuo1,
        meta: {
            title: "更多商品",
            keepAlive: true
        }
    },

    {
        path: "/collage",
        name: "collage",
        component: collage,
        meta: {
            title: "拼团",
        }
    },
    {
        path: "/logistics",
        name: "logistics",
        component: logistics,
        meta: {
            title: "查看物流",
            isLogin: true,
        }
    },

    {
        path: "/activDetailsWarp",
        name: "activDetailsWarp",
        component: activDetailsWarp,
        meta: {
            title: "活动页",
            keepAlive: true,
        }
    },
    {
        path: "/advertisement",
        name: "advertisement",
        component: advertisement,
        meta: {
            title: "广告图"
        }
    },

    {
        path: "/shezhi",
        name: "shezhi",
        component: shezhi,
        meta: {
            title: "设置"
        }
    },
    {
        path: "/addressUpdataX",
        name: "addressUpdataX",
        component: addressUpdataX,
        meta: {
            title: "新增收货人",
            isLogin: true,
        }
    },
    {
        path: "/WJpassword",
        name: "WJpassword",
        component: WJpassword,
        meta: {
            title: "找回密码"
        }
    },
    {
        path: "/loginYzm",
        name: "loginYzm",
        component: loginYzm,
        meta: {
            title: "验证码登录"
        }
    },
    {
        path: "/loginMima",
        name: "loginMima",
        component: loginMima,
        meta: {
            title: "账号密码登录",
            isLogin: false,
        }
    },
    {
        path: "/ShopList",
        name: "ShopList",
        component: ShopList,
        meta: {
            // keepAlive: true
        },
        children: [{
            path: "",
            name: "productlist",
            component: productlist,
            meta: {
                keepAlive: true
            }
        }]
    },
    {
        path: "/changeInfo",
        name: "changeInfo",
        component: changeInfo,
        meta: {
            title: "信息编辑",
            isLogin: true,
        }
    },
    {
        path: "/wSzizhi",
        name: "wSzizhi",
        component: wSzizhi,
        meta: {
            title: "上传资质信息",
            isLogin: true,
        }
    },
    {
        path: "/ShopDetails",
        name: "ShopDetails",
        component: ShopDetails,
        meta: {
            title: "商品详情",
            keepAlive: false // 不需要缓存
        }
    },
    {
        path: "/groupDetails",
        name: "groupDetails",
        component: groupDetails,
        meta: {
            title: "商品详情",
            keepAlive: false // 不需要缓存
        }
    },
    {
        path: "/ShopDetailscoll",
        name: "ShopDetailscoll",
        component: ShopDetailscoll,
        meta: {
            title: "拼团商品详情",
            keepAlive: false // 不需要缓存
        }
    },
    {
        path: "/buyerQuery",
        name: "buyerQuery",
        component: buyerQuery,
        meta: {
            title: "拼团客户",
            keepAlive: false // 不需要缓存
        }
    },
    {
        path: "/tetui",
        name: "tetui",
        component: tetui,
        meta: {
            title: "特推商品",
            keepAlive: false // 不需要缓存
        }
    },
    {
        path: "/ShopDetailsPL",
        name: "ShopDetailsPL",
        component: ShopDetailsPL,
        meta: {
            title: "评论"
        }
    },

    {
        path: "/OrderList",
        name: "OrderList",
        component: OrderList,
        meta: {
            title: "订单列表",
            keepAlive: true,
            isLogin: true,
        }
    },
    {
        path: "/OrderListDetails",
        name: "OrderListDetails",
        component: OrderListDetails,
        meta: {
            title: "订单详情",
            isLogin: true,
        }
    },
    {
        path: "/GouwucheTJDD",
        name: "GouwucheTJDD",
        component: GouwucheTJDD,
        meta: {
            title: "购物车订单提交",
            isLogin: true,

        }
    },
    {
        path: "/GuoWuCheDel",
        name: "GuoWuCheDel",
        component: GuoWuCheDel,
        meta: {
            title: "购物车商品删除",
            isLogin: true,
        }
    },
    {
        path: "/Register",
        name: "Register",
        component: Register,
        meta: {
            title: "注册"
        }
    },
    {
        path: "/MyYHJ",
        name: "MyYHJ",
        component: MyYHJ,
        meta: {
            title: "我的优惠",
            isLogin: true,
        }
    },
    {
        path: "/UserInfo",
        name: "UserInfo",
        component: UserInfo,
        meta: {
            title: "我的优惠",
            isLogin: true,
        }
    },
    {
        path: "/Address",
        name: "Address",
        component: Address,
        meta: {
            title: "我的地址",
            isLogin: true,
        }
    },
    {
        path: "/AddressUpdata",
        name: "AddressUpdata",
        component: AddressUpdata,
        meta: {
            title: "地址编辑",
            isLogin: true,
        }
    },
    {
        path: "/MySC",
        name: "MySC",
        component: MySC,
        meta: {
            title: "我的收藏",
            isLogin: true,
        }
    },
    {
        path: "/ResetPassword",
        name: "ResetPassword",
        component: ResetPassword,
        meta: {
            title: "修改密码"
        }
    },
    {
        path: "/OrderDetailsCZ",
        name: "OrderDetailsCZ",
        component: OrderDetailsCZ,
        meta: {
            title: "订单操作",
            isLogin: true,
        }
    },
    {
        path: "/Pingjia",
        name: "Pingjia",
        component: Pingjia,
        meta: {
            title: "评价"
        }
    },
    {
        path: "/LqYHJ",
        name: "LqYHJ",
        component: LqYHJ,
        meta: {
            title: "领取优惠券",
            isLogin: true,
        }
    },
    {
        path: "/Ok",
        name: "Ok",
        component: Ok,
        meta: {
            title: "支付成功",
            isLogin: true,
        }
    },
    {
        path: "/Merchant",
        name: "Merchant",
        component: Merchant,
        meta: {
            title: "商铺",
            keepAlive: true
        }
    },
    {
        path: "/shop",
        name: "shop",
        component: shop,
        meta: {
            title: "商铺列表",
        },
        children: [{
            path: "",
            name: "shoplist",
            component: shoplist,
            meta: {
                title: "商铺列表",
            },
        }]
    },
    {
        path: "/Hdong",
        name: "hdong",
        component: Hdong,
        meta: {
            title: "活动"
        }
    },
    {
        path: "/Chgzhifu",
        name: "chgzhifu",
        component: Chgzhifu,
        meta: {
            title: "支付成功",
            isLogin: true,
        }
    },
    {
        path: "/Yinsi",
        name: "yinsi",
        component: Yinsi,
        meta: {
            title: "隐私协议",
        }
    },
    {
        path: "/Fuwu",
        name: "fuwu",
        component: Fuwu,
        meta: {
            title: "服务协议"
        }
    },
    {
        path: "/Bangka",
        name: "bangka",
        component: Bangka,
        meta: {
            title: "银行卡绑定"
        }
    },
    {
        path: "/Qrbangk",
        name: "qrbangk",
        component: Qrbangk,
        meta: {
            title: "确认绑卡"
        }
    },
    {
        path: "/openbank",
        name: "openbank",
        component: Openbank,
        meta: {
            title: "开户申请"
        }
    },
    {
        path: "/Zhong",
        name: "Zhong",
        component: Zhong
    },
    {
        path: "/ceshi",
        name: "ceshi",
        component: ceshi,
        meta: {
            title: "客户"
        }
    },
    {
        path: "/videolist",
        name: "videolist",
        component: videolist,
        meta: {
            title: "视频学习"
        }
    },
    {
        path: "/videochapter",
        name: "videochapter",
        component: videochapter,
        meta: {
            title: "视频学习章节"
        }
    },

    {
        path: "/videodetails",
        name: "videodetails",
        component: videodetails,
        meta: {
            title: "视频学习详情"
        }
    },

    {
        path: "/hdongy",
        name: "hdongy",
        component: hdongy,
        meta: {
            title: "活动"
        }
    },
    {
        path: "/footprint",
        name: "footprint",
        component: footprint,
        meta: {
            title: "足迹"
        }
    },

    {
        path: "/broadcast",
        name: "broadcast",
        component: broadcast,
        meta: {
            title: "直播"
        }
    },

    {
        path: "/enterbroadcast",
        name: "enterbroadcast",
        component: enterbroadcast,
        meta: {
            title: "直播间"
        }
    },

    {
        path: "/KFservice",
        name: "KFservice",
        component: KFservice,
        meta: {
            title: "客户服务"
        }
    },

    {
        path: "/returnGoods",
        name: "returnGoods",
        component: returnGoods,
        meta: {
            title: "申请退款",
            isLogin: true,
        }
    },
    {
        path: "/returnGoods1",
        name: "returnGoods1",
        component: returnGoods1,
        meta: {
            title: "申请退货退款",
            isLogin: true,
        }
    },
    {
        path: "/returnGoods2",
        name: "returnGoods2",
        component: returnGoods2,
        meta: {
            title: "申请退货退款",
            isLogin: true,
        }
    },
    {
        path: "/refundInformation",
        name: "refundInformation",
        component: refundInformation,
        meta: {
            title: "退款详情",
            isLogin: true,
        }
    },
    {
        path: "/news",
        name: "news",
        component: news,
        meta: {
            title: "新闻"
        }
    },
    {
        path: "/newlist",
        name: "newlist",
        component: newlist,
        meta: {
            title: "新闻列表"
        }
    },
    {
        path: "/shopNotice",
        name: "shopNotice",
        component: shopNotice,
        meta: {
            title: "公告信息"
        }
    },
    {
        path: "/newShop",
        name: "newShop",
        component: newShop,
        meta: {
            title: "新品登记",
            isLogin: true,
        }
    },
    {
        path: "/newShopResgister",
        name: "newShopResgister",
        component: newShopResgister,
        meta: {
            title: "新品登记",
            isLogin: true,
        }
    },
    {
        path: "/banklist",
        name: "banklist",
        component: banklist,
        meta: {
            title: "绑卡列表"
        }
    },
    {
        path: "/photocopy",
        name: "photocopy",
        component: photocopy,
        meta: {
            title: "采集影件"
        }
    },
    {
        path: "/openAccount",
        name: "openAccount",
        component: openAccount,
        meta: {
            title: "企业绑卡"
        }
    },
    {
        path: "/seeInvoice",
        name: "seeInvoice",
        component: Invoice,
        meta: {
            title: "查看发票",
        }
    }, {
        path: "/OfThePublic",
        name: "OfThePublic",
        component: OfThePublic,
        meta: {
            title: "对公支付",
        }
    }, {
        path: "/aboutUs",
        name: "aboutUs",
        component: aboutUs,
        meta: {
            title: "关于我们",
        }
    },
    {
        path: "/theCharts",
        name: "theCharts",
        component: theCharts,
        meta: {
            title: "TOP排行",
        }
    },
    {
        path: "/activityDetails",
        name: "activityDetails",
        component: activityDetails,
        meta: {
            title: "套餐包详情",
        }
    },
    {
        path: "/bigWheel",
        name: "bigWheel",
        component: bigWheel,
        meta: {
            title: "抽奖活动",
        }
    },
    {
        path: "/iframe",
        name: "iframe",
        component: iframes,
        meta: {
            title: "抽奖活动",
        }
    },

    ]
})
route.beforeEach((to, from, next) => {
    if (from.meta.title) {
        var params = {
            startTime: "",
            endTime: new Date().getTime(),
            pageUrl: from.path,
            productId: "",
            pageName: "",
            type: 'APP'
        }
        if (from.meta.title == '康药药控销商城') {
            params.pageName = from.meta.name
        } else {
            params.pageName = from.meta.title
        }
        if (from.query.productId && from.path == '/ShopDetails') {
            params.productId = from.query.productId
        }
        if (localStorage.getItem('startTime')) {
            params.startTime = Number(localStorage.getItem('startTime'))
        }
        localStorage.setItem('startTime', new Date().getTime())
        myaxios.buyerviewPage(params).then(res => {
            console.log(res, "测试");
        })
    }
    //to是到达的页面
    //from是离开的页面
    if (to.name === "Shouye") store.state.tabNum = 0
    if (to.name === "homeClassify") store.state.tabNum = 1
    if (to.name === "activDetails") store.state.tabNum = 2
    if (to.name === "shopCart") store.state.tabNum = 3
    if (to.name === "MyShop") store.state.tabNum = 4
    store.commit("tabs", {
        key: "to",
        value: to
    })
    store.commit("tabs", {
        key: "from",
        value: from
    })
    console.log(from,to);
    localStorage.setItem('to',to.name)
    
    if (from.name == 'Merchant'&&to.name!='ShopDetails') {
        localStorage.removeItem("Merchant")
    }
    if (from.name == 'Shouye' || from.name == 'activDetails' || from.name == "homeClassify" || from.name == "MyShop" || from.name == "loginMima") {
        localStorage.setItem("keepAlive", false)
    } else {
        localStorage.setItem("keepAlive", true)
    }
    if (to.name === "activDetails" || to.name === "shopCart" || to.name === "MyShop" || to.meta.isLogin) {
        if (JSON.parse(localStorage.getItem("user_xinxi")) != null) {
            next()
        } else {
            route.push(`/loginMima`)
            next();
        }
    } else {
        next();
    }

})
export default route;


// WEBPACK FOOTER //
// ./src/router/index.js